import {
  CANDIDATE_JOB_PLANNED_REQUEST,
  CANDIDATE_JOB_PLANNED_SUCCESS,
  CANDIDATE_JOB_PLANNED_FAIL,
  CANDIDATE_JOB_PLANNED_V2_REQUEST,
  CANDIDATE_JOB_PLANNED_V2_SUCCESS,
  CANDIDATE_JOB_PLANNED_V2_FAIL,
} from "../constants/AuthConstant";
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_PATH;

export const CandidateInterviewPlanned = (id, pageNumber) => {
  return function (dispatch) {
    dispatch({
      type: CANDIDATE_JOB_PLANNED_REQUEST,
      payload: true,
    });
    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/interview/get_interview_scheduled_by_candidateId?candidateId=${id}&pageNumber=${pageNumber}&pageSize=10&flag=true`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };
    axios(OPTION)
      .then((res) => {
        dispatch(loadAllDetailsPre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: CANDIDATE_JOB_PLANNED_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
      });
  };
};

export const CandidateInterviewPlannedV2 = ({ candidateId }) => {
  return async (dispatch) => {
    dispatch({
      type: CANDIDATE_JOB_PLANNED_V2_REQUEST,
      payload: true,
    });

    try {
      const res = await axios.get(`${baseUrl}/ebench/candidate/availability`, {
        params: {
          candidateId,
        },
        headers: {
          "content-type": "application/json",
        },
      });

      dispatch({
        type: CANDIDATE_JOB_PLANNED_V2_SUCCESS,
        scheduleInterviews: res.data,
        payload: false,
        msg: "SUCCESS",
      });
    } catch (error) {
      dispatch({
        type: CANDIDATE_JOB_PLANNED_V2_FAIL,
        payload: false,
        error,
        msg: "Failed to load planned interviews",
      });
    }
  };
};

export const loadAllDetailsPre = (data) => {
  return {
    type: CANDIDATE_JOB_PLANNED_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};
